<template>
  <div :data-fg-id="id">
    <slot :active-error="activeErrors" :first-error="firstError" />
  </div>
</template>

<script>
  import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';
  import kebab from 'lodash.kebabcase';

  export default {
    mixins: [singleErrorExtractorMixin],
    inject: ['$form'],
    computed: {
      id() {
        return kebab(`${this.$form.formName} ${this.$parent.name}`);
      },
    },
  };
</script>
